import React from 'react';

export function useClickOutside(cb) {
    const ref = React.useRef(null);

    const handler = React.useCallback(event => cb(event), [cb]);

    function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            handler(event);
        }
    }

    React.useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    });

    return ref;
}
